import * as React from "react";
export var defaultLanguage = "en-US";
var LocalizationContext = React.createContext({
  language: defaultLanguage
});
export default LocalizationContext;